export function preprocessXYCursorContent(content: string): string {
    const xyCursorRegex = /%%(XYCRSR|FLEX)%%(.*?)%%(XYCRSR|FLEX)%%/gs;
    
    let processedContent = content;
    let match;
    let index = 0;
    
    while ((match = xyCursorRegex.exec(content)) !== null) {
      try {
        const jsonString = match[2].trim();
        const xyCursorData = JSON.parse(jsonString);
        
        // Create a unique ID for this instance
        const uniqueId = `xycursor-${xyCursorData.id || index}`;
        
        // Replace the delimiter content with a placeholder div that React will hydrate
        const replacement = `<div class="xycursor-container" data-xycursor='${JSON.stringify(xyCursorData).replace(/'/g, "&apos;")}' id="${uniqueId}"></div>`;
        
        processedContent = processedContent.replace(match[0], replacement);
        index++;
      } catch (error) {
        console.error('Error parsing XYCursor JSON:', error);
      }
    }
  
    return processedContent;
  }